import { Component, Input } from '@angular/core';
import { BulletPoints } from '@boels/models';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'boels-product-key-features',
  templateUrl: './product-key-features.component.html',
  styleUrls: ['./product-key-features.component.scss'],
  imports: [TranslocoModule, FontAwesomeModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productDetails'],
    },
  ],
})
export class ProductKeyFeaturesComponent {
  @Input() bulletPoints?: BulletPoints[];

  faCheck = faCheck;
}
